import TemplateSpray from './template-spray';

export default TemplateSpray;